import { render, staticRenderFns } from "./ConsultantNotLoggedInNavLocaleSelector.vue?vue&type=template&id=971943ce&scoped=true"
import script from "./ConsultantNotLoggedInNavLocaleSelector.vue?vue&type=script&lang=js"
export * from "./ConsultantNotLoggedInNavLocaleSelector.vue?vue&type=script&lang=js"
import style0 from "./ConsultantNotLoggedInNavLocaleSelector.vue?vue&type=style&index=0&id=971943ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971943ce",
  null
  
)

/* custom blocks */
import block0 from "./ConsultantNotLoggedInNavLocaleSelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports